import { render, staticRenderFns } from "./UserHelpHistory.vue?vue&type=template&id=de2afa44&lang=html"
import script from "./UserHelpHistory.vue?vue&type=script&lang=js"
export * from "./UserHelpHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports